import * as React from "react";

/**
 * Constant
 */

const GTM_HEAD_SCRIPT_ID = "gtmHeadScript";
const GTM_BODY_NOSCRIPT_ID = "gtmBodyNoscript";

/**
 * Function
 */

/**
 * GTMのスクリプトをhead要素のはじめの子要素として設置する
 * @param gtmId GoogleタグマネージャーID
 */
const createGtmHeadScript = (gtmId: string) => {
  if (document.querySelector(`head > #${GTM_HEAD_SCRIPT_ID}`)) return;

  const addScript = document.createElement("script");
  addScript.type = "text/javascript";
  addScript.id = GTM_HEAD_SCRIPT_ID;
  addScript.innerText = `(function (w, d, s, l, i) {
      w[l] = w[l] || [];
      w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != "dataLayer" ? "&l=" + l : "";
      j.async = true;
      j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
      f.parentNode.insertBefore(j, f);
    })(window, document, "script", "dataLayer", "${gtmId}");`;

  const headElement = document.getElementsByTagName("head")[0];
  headElement.insertBefore(addScript, headElement.firstChild);
};

/**
 * GTMのスクリプトをbody要素のはじめの子要素として設置する
 * @param gtmId GoogleタグマネージャーID
 */
const createGtmBodyNoScript = (gtmId: string) => {
  if (document.querySelector(`body > #${GTM_BODY_NOSCRIPT_ID}`)) return;

  const iframe = document.createElement("iframe");
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = "0";
  iframe.width = "0";
  iframe.style.display = "none";
  iframe.style.visibility = "hidden";

  const addScript = document.createElement("noscript");
  addScript.id = GTM_BODY_NOSCRIPT_ID;
  addScript.append(iframe);

  const bodyElement = document.getElementsByTagName("body")[0];
  bodyElement.insertBefore(addScript, bodyElement.firstChild);
};

/**
 * 指定のIDが設定されているエレメントを削除する
 * @param id ID
 */
const deleteElement = (id: string) => {
  const element = document.querySelector(`#${id}`);
  if (element) {
    element.remove();
  }
};

/**
 * Component
 */

type Props = {
  gtmId: string | undefined;
};

const GoogleTagManager = ({ gtmId }: Props) => {
  React.useEffect(() => {
    if (gtmId) {
      createGtmHeadScript(gtmId);
      createGtmBodyNoScript(gtmId);
    } else {
      /*
        Note: 以下ユースケース(利用シーンは低い)の場合に、ページビューが計測されるのを防ぐためタグが存在する場合は削除する
         1. 条件入力画面表示(gtmId設定あり)
         2. featureの設定からgtmIdを削除
         3. AI査定をおこなうボタンをクリックしてAI査定完了画面に遷移
      */
      deleteElement(GTM_HEAD_SCRIPT_ID);
      deleteElement(GTM_BODY_NOSCRIPT_ID);
    }
  }, [gtmId]);

  return <></>;
};

export default GoogleTagManager;
